// Default fallback in case the header items can't be loaded via fetch.
// Structure should match the "items" field in /config/mcp-header/v2/menuitems.
// See readme.txt file in that directory for more information.
export default [
  {
    id: 'orders',
    text: 'Orders',
    svg: 'shopping-cart-full',
    subItems: [
      {
        id: 'oops',
        text: 'Order Operations Tool',
        url: 'https://orderoperations.cimpress.io',
      },
      {
        id: 'opa',
        text: 'Order Placement App',
        url: 'https://order-placement.mex.cimpress.io',
      },
      {
        id: 'pom',
        text: 'Production Order Manager',
        url: 'https://pom.cimpress.io/',
      },
      {
        id: 'invoiceManager',
        text: 'Invoice Manager',
        url: 'https://manage.invoices.cimpress.io/',
      },
      {
        id: 'billableEntityManager',
        text: 'Billable Entity Manager',
        url: 'https://billableentitymanager.financialflows.cimpress.io/',
      },
      {
        id: 'supplierPerformance',
        text: 'Supplier Performance',
        url: 'https://supplierperformance.cimpress.io/',
      },
    ],
  },
  {
    id: 'products',
    text: 'Product Information Management (PIM)',
    svg: 't-shirt',
    subItems: [
      {
        id: 'pim',
        text: 'PIM Dashboard',
        url: 'https://pim.cimpress.io/',
      },
      {
        id: 'merchandisingProducts',
        text: 'Products',
        url: 'https://pim.products.cimpress.io/',
      },
      {
        id: 'productManager',
        text: 'Product Manager',
        url: 'https://productmanager-v2.products.cimpress.io/',
      },
      {
        id: 'pricingManager',
        text: 'Pricing Manager',
        url: 'https://pricingmanager.financialflows.cimpress.io/',
      },
      {
        id: 'productCatalog',
        text: 'Catalog',
        url: 'https://catalog.products.cimpress.io',
      },
    ],
  },
  {
    id: 'customization',
    text: 'Artwork Prep and Customization',
    svg: 'design-mug',
    subItems: [
      {
        id: 'prepress',
        text: 'Print Profile Manager',
        url: 'https://console.prepress.cimpress.io',
      },
      {
        id: 'prepressflow',
        text: 'Prepress Flow',
        url: 'https://prepress-flow.prepress.cimpress.io/',
      },
      {
        id: 'filereview',
        text: 'File Review',
        url: 'https://review.filereview.cimpress.io/',
      },
      {
        id: 'stitchx',
        text: 'StitchX',
        url: 'https://stitchx.embroidery.cimpress.io/',
      },
      {
        id: 'scenemaker',
        text: 'Scene Maker',
        url: 'https://scenemaker.cimpress.io/',
      },
      {
        id: 'designer',
        text: 'Cimpress Designer',
        url: 'https://designer.cimpress.io/',
      },
      {
        id: 'templatemaker',
        text: 'Template Maker',
        url: 'https://templatemaker.contentauthoring.cimpress.io/',
      },
      {
        id: 'contentAssetManager',
        text: 'Content Asset Manager',
        url: 'https://cam.contentauthoring.cimpress.io/',
      },
    ],
  },
  {
    id: 'logistics',
    text: 'Logistics',
    svg: 'truck-1',
    subItems: [
      {
        id: 'logisticsConfiguration',
        text: 'Logistics Configuration',
        url: 'https://logistics.cimpress.io/',
      },
      {
        id: 'shippingConsole',
        text: 'Shipping Console',
        url: 'https://console.shipping.cimpress.io/',
      },
      {
        id: 'shippingManagementConsole',
        text: 'Shipping Management Console',
        url: 'https://my.shipping.cimpress.io/',
      },
      {
        id: 'shippingBoxes',
        text: 'Shipping Boxes',
        url: 'https://boxman.logistics.cimpress.io/',
      },
      {
        id: 'sortman',
        text: 'Sortman',
        url: 'https://sorting.cimpress.io/',
      },
      {
        id: 'quoterConfiguration',
        text: 'Carrier Contract Manager',
        url: 'https://qcm.qp.cimpress.io/',
      },
      {
        id: 'shippingRecommendations',
        text: 'Shipping Recommendations',
        url: 'https://shiprec.qp.cimpress.io/',
      },
      {
        id: 'productionTime',
        text: 'Production Time',
        url: 'https://productiontime.dnj.cimpress.io/ui/',
      },
    ],
  },
  {
    id: 'ecommerce',
    text: 'E-Commerce',
    svg: 'store',
    subItems: [
      {
        id: 'abc',
        text: 'ABC',
        url: 'https://admin.abc.cimpress.io/organizations',
      },
    ],
  },
  {
    id: 'analytics',
    text: 'Reporting and Analytics',
    svg: 'graph-pie-2',
    subItems: [
      {
        id: 'data-portal',
        text: 'Data Portal',
        url: 'https://data.cimpress.io/',
      },
      {
        id: 'river',
        text: 'River',
        url: 'https://console.river.cimpress.io/',
      },
      {
        id: 'transformer',
        text: 'Transformer',
        url: 'https://console.transformer.cimpress.io/',
      },
      {
        id: 'looker',
        text: 'Looker',
        url: 'https://cimpress.eu.looker.com/?utm_source=mcp_ui&utm_medium=hamburger&utm_campaign=link',
      },
      {
        id: 'data-discovery',
        text: 'Data Discovery',
        url: 'https://data-discovery.cimpress.io/',
      },
      {
        id: 'pdw-access',
        text: 'PDW Access Management',
        url: 'https://manage-access.pdw.cimpress.io/',
      },
    ],
  },
  {
    id: 'accounts',
    text: 'Account and Setup',
    svg: 'person-setting-2',
    subItems: [
      {
        id: 'accountManagementDashboard',
        text: 'Account Management Dashboard',
        url: 'https://access.cimpress.io/',
      },
      {
        id: 'coam',
        text: 'Access Management',
        url: 'https://users.cimpress.io/',
      },
      {
        id: 'supplierProfile',
        text: 'Supplier Profile',
        url: 'https://supplierprofile.cimpress.io/',
      },
      {
        id: 'fulfillmentProcessSetup',
        text: 'Fulfillment Process Setup',
        url: 'https://fulfillmentconfigurations.cimpress.io/',
      },
    ],
  },
  {
    id: 'apis',
    text: 'APIs',
    url: 'https://mcpapis.cimpress.io/?redirected=true',
    svg: 'folder-code',
  },
  {
    id: 'documentation',
    text: 'Documentation',
    url: 'https://developer.cimpress.io/docs/',
    svg: 'book-open-4',
  },
];
